import dayjs from 'dayjs';
import { Nullable } from 'common-types';
import { logger } from 'logging-utils';

export const getLocalTime = (epochTimeSec: number) => {
  const date = new Date(epochTimeSec * 1000);

  return date.toLocaleString();
};

export const getOneDayAgo = () => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday;
};

export const getTimeSec = (date: Nullable<dayjs.Dayjs>) => {
  try {
    if (!date) {
      return null;
    }

    return date.toDate();
  } catch (error) {
    logger.error('Failed to get date, fallback to 24h', error);
    return null;
  }
};
